import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';
import { httpService } from '../../../utils/apiService';

export const useFetchChargerList = (pagination, operatorId, status) => {
  const { offset, limit, search } = pagination;

  return useQuery({
    queryKey: ['chargerList', offset, limit, search, operatorId, status],
    queryFn: async () => {
      const params = queryString.stringify({ offset, limit, search, status });
      const response = await httpService.post(`charger/list?${params}`, {
        operatorId,
      });

      return response.data;
    },
    staleTime: 5000,
    refetchOnWindowFocus: false,
  });
};

export const useQuickChargerSearch = (pagination, operatorId, status) => {
  const { offset, limit, search } = pagination;

  return useQuery({
    queryKey: ['chargerList', offset, limit, search, operatorId, status],
    queryFn: async () => {
      const params = queryString.stringify({ offset, limit, search, status });
      const response = await httpService.post(`charger/list?${params}`, {
        operatorId,
      });

      return response.data;
    },
    staleTime: 5000,
    enabled: !!search,
    refetchOnWindowFocus: false,
  });
};

